import {forwardRef, useEffect, useImperativeHandle, useRef, useState} from "react";
import {IconClose} from "../../Icon";
import {Button, Checkbox, ConfigProvider, message, Modal} from "antd";
import {t} from "i18next";
import {batchUpdateTags, getGroupList} from "@model/tag";
import {ARRAY_COLORS} from "@/Const";

const DialogChangeColor = forwardRef((props:{onUpdate:any},ref)=>{
    useImperativeHandle(ref, () => ({
        onShowDialog: onShowDialog
    }))


    const [isShowDialog, setIsShowDialog] = useState(false);
    const [arrayColors,setArrayColors] = useState<any>([]);
    const mInputRef = useRef(null);
    const mArraySelectTags = useRef(null);

    const getColors = ()=>{
        const TAG_COLOR_OPTIONS = [
            {
                value:'#E8E9ED',
                name:t("Default"),
                label: <div className={'flex-row-vertical-center'}>
                    <div style={{
                        background: '#E8E9ED',
                        width: '14px',
                        height: '14px',
                        borderRadius: '7px'
                    }}></div>
                    <span className={'ml-6'}>
                                    {t("Default")}
                                </span>
                </div>,
            },
            {
                value: '#FEE2E1',
                name:t("Red"),
                label: <div className={'flex-row-vertical-center'}>
                    <div style={{
                        background: '#FEE2E1',
                        width: '14px',
                        height: '14px',
                        borderRadius: '7px'
                    }}></div>
                    <span className={'ml-6'}>
                                    {t("Red")}
                                </span>
                </div>
            },
            {
                value: '#DCFCE7',
                name:t("Green"),
                label: <div className={'flex-row-vertical-center'}>
                    <div style={{
                        background: '#DCFCE7',
                        width: '14px',
                        height: '14px',
                        borderRadius: '7px'
                    }}></div>
                    <span className={'ml-6'}>
                                    {t("Green")}
                                </span>
                </div>
            },
            {
                value: '#DBEAFE',
                name:t("Blue"),
                label: <div className={'flex-row-vertical-center'}>
                    <div style={{
                        background: '#DBEAFE',
                        width: '14px',
                        height: '14px',
                        borderRadius: '7px'
                    }}></div>
                    <span className={'ml-6'}>
                                    {t("Blue")}
                                </span>
                </div>
            },
            {
                value: '#FFF9C3',
                name:t("Yellow"),
                label: <div className={'flex-row-vertical-center'}>
                    <div style={{
                        background: '#FFF9C3',
                        width: '14px',
                        height: '14px',
                        borderRadius: '7px'
                    }}></div>
                    <span className={'ml-6'}>
                                    {t("Yellow")}
                                </span>
                </div>
            },
            {
                value: '#F3E9FF',
                name:t("Purple"),
                label: <div className={'flex-row-vertical-center'}>
                    <div style={{
                        background: '#F3E9FF',
                        width: '14px',
                        height: '14px',
                        borderRadius: '7px'
                    }}></div>
                    <span className={'ml-6'}>
                                    {t("Purple")}
                                </span>
                </div>
            },
            {
                value: '#FBE7F3',
                name:t("Pink"),
                label: <div className={'flex-row-vertical-center'}>
                    <div style={{
                        background: '#FBE7F3',
                        width: '14px',
                        height: '14px',
                        borderRadius: '7px'
                    }}></div>
                    <span className={'ml-6'}>
                                    {t("Pink")}
                                </span>
                </div>
            }
        ];
        return TAG_COLOR_OPTIONS;
    }


    const onShowDialog = (arraySelectTags:any)=>{
        setIsShowDialog(true);
        mArraySelectTags.current = arraySelectTags;
        setArrayColors(getColors());

        setTimeout(()=>{
            mInputRef.current?.focus();
        },100)
    }

    return <Modal width={520} zIndex={2005} bodyStyle={{height: `${380}px`}}
                  afterClose={() => {

                  }}
                  destroyOnClose={true}
                  open={isShowDialog} centered={true} closable={false} closeIcon={<IconClose/>} footer={null}
                  onCancel={() => {
                      setIsShowDialog(false)
                  }}>
        <div style={{height: '100%', width: '100%', display: 'flex', flexDirection: 'column'}}>
            <div className={'flex-center'} style={{flexShrink: '0'}}>
                <span className={'dialog-title'}>{t("Change color")}</span>
                {/*<div style={{flexGrow: '1'}}/>*/}
            </div>
            <div className={'line0 mt-12'} style={{margin: '12px -22px'}}></div>

            <input ref={mInputRef} autoFocus={true} className={'input-border'} placeholder={t("Search color")} onChange={(event)=>{
                let arrayNew:any = [];
                const szInput = event.target.value.toLowerCase();
                if (szInput) {
                    arrayNew = getColors().filter(p=>p.name?.toLowerCase().includes(szInput))
                }else {
                    arrayNew.push(...getColors());
                }
                setArrayColors(arrayNew);
            }}/>
            <div className={'flex-col mt-10'} style={{border:'1px solid var(--border-color)',
                borderRadius:'8px',height:'auto',padding:'8px 0px',
                boxShadow:'var(--dialog-box-shadow)',
                overflow:'auto'
            }}>
                {
                    arrayColors.map((item)=> {
                        return <div className={'flex-row-vertical-center dropdown-item'} style={{padding:'0 16px'}} onClick={()=>{
                            //移动到该组，然后刷新...
                            mArraySelectTags.current?.forEach(p=>{
                                p.backgroundColor = item.value;
                                delete p.isSelected;
                            })
                            //批量保存.
                            batchUpdateTags(mArraySelectTags.current);
                            props.onUpdate();
                            setIsShowDialog(false);
                        }}>
                            <div style={{
                                background: item.value,
                                width: '14px',
                                height: '14px',
                                borderRadius: '7px'
                            }}></div>
                            <span className={'ml-6'}>
                                    {item.name}
                                </span>
                        </div>
                    })
                }
            </div>
        </div>
    </Modal>
})

export default DialogChangeColor;